import { render, staticRenderFns } from "./SaveOnLeaveDlg.vue?vue&type=template&id=28e8fb32&scoped=true"
import script from "./SaveOnLeaveDlg.vue?vue&type=script&lang=js"
export * from "./SaveOnLeaveDlg.vue?vue&type=script&lang=js"
import style0 from "./SaveOnLeaveDlg.vue?vue&type=style&index=0&id=28e8fb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8fb32",
  null
  
)

export default component.exports